import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StiiraError } from '@core/models';
import { ApplicationInsightsService, AuthService, ErrorService, NotificationService, RedirectService } from '@core/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { appRoutePaths } from '@core/routes/route-paths.constants';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private errorService: ErrorService,
    private notifyService: NotificationService,
    private router: Router,
    private redirectService: RedirectService,
    private aiService: ApplicationInsightsService,
  ) {}

  intercept(req: HttpRequest<any>, newReq: HttpHandler): Observable<HttpEvent<any>> {
    return newReq.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const stiiraError: StiiraError = this.errorService.createStiiraError(error);
        
        if (stiiraError.modelStateErrors == null) {
          // log non-model state error to application insights
          this.aiService.trackTraceError(stiiraError.globalError);
        }

        // sylvania is unreachable during launch
        if (!this.authService.isAuth
          // exclude anonymous submit pages, which are the only pages
          // other than login that will exist while isAuth is false
          && (!req.url.toLowerCase().includes("postanonymous") || !req.url.toLowerCase().includes("request"))) {
          if (this.errorService.isLaunchConnectionError(error)) {
            this.notifyService.showErrorToast(this.errorService.launchErrorMessage, "Communication Error", "launch-error-message")
            return throwError(this.errorService.launchErrorMessage);
          }
        }

        // unauthorized
        if (error.status == 401) {
          // get last url navigated to before logout routes to login
          const url = this.redirectService.lastNavigationUrl;
          // then logout (will 'resetRedirectUrl')
          this.authService.logout();
          // then set redirect 
          this.redirectService.setRedirectUrl = url;
        }

        // handle url query parameters returning a 500
        if (this.authService.isUrlWithQueryParams && this.authService.isAuth && error.status == 500) {
          this.authService.setIsUrlWithQueryParams(false);
          this.router.navigate([appRoutePaths.HOME]);
        }

        // handle file size upload returning a 413 "content too large"
        if (error.status == 413) {
          this.notifyService.showErrorToast(this.errorService.tooLargeMessage);
        }

        // check for the non-specific failure
        else if (error.status == 0 && error.statusText.toLowerCase() == "unknown error") {
          this.notifyService.showErrorToast(this.errorService.unableToComplete);
        }
        
        // display global error
        else if (stiiraError.globalError) {
          this.notifyService.showErrorToast(stiiraError.globalError);
        }

        return throwError(stiiraError);
      })
    );
  }
}
